import { useState as i, useEffect as r } from "react";
import { css as a } from "styled-components";
const n = () => {
  const [t, o] = i(!1), e = () => {
    o(!0);
  };
  return r(() => {
    t && setTimeout(() => {
      o(!1);
    }, 400);
  }, [t]), {
    isClickMotion: t,
    startClickMotion: e
  };
}, l = (t = "200%") => a(["position:relative !important;overflow:hidden !important;display:flex;justify-content:center;align-items:center;&::before{content:'';position:absolute;aspect-ratio:1/1;min-width:", ";min-height:", ";border-radius:var(--border-radius-circular);animation:hoverEffect var(--duration-slow-01) var(--curve-productive-exit);background-color:var(--_active-click-background-color);z-index:0;transform:scale(0);}@keyframes hoverEffect{0%{transform:scale(0);opacity:1;}100%{transform:scale(1);opacity:0;}}"], t, t);
export {
  l as c,
  n as u
};
